import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=65c2ef42"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=65c2ef42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports